//The modals component declaration
'use strict';
import angular from 'angular';
import './scripts/modals.ctrls';
import './scripts/modals.directives';
import './scripts/modals.services';

angular.module('modals', ['modals.ctrls', 'modals.directives', 'modals.services']);
